export default __webpack_public_path__ + "static/media/icon_Temperature.fc51299e.svg";